import React, { useState } from "react";
import "./index.scss";

export default function Playground() {
  return <div className="playground-container">Playground</div>;
}
